(function () {
	const script = document.currentScript;
	const config = script ? script.dataset : {};
	const fontUrl = config.fontUrl || '';
	const appId = config.appId || '';
	const convertId = config.convertId || '';
	// Seconds of idle after `load` before the widget loads by itself; 0 = only on click.
	const loadDelay = Math.max(0, Number(config.loadDelay ?? 4) || 0);
	const launcher = () => document.querySelector('[data-gorgias-launcher]');
	const CONTAINER = '#gorgias-chat-container';

	const fontFace = fontUrl
		? '@font-face { font-family: "Aeyde Grotesk"; src: url("' + fontUrl + '") format("woff2"); font-weight: normal; font-style: normal; font-display: swap; } '
		: '';

	const customCSS = fontFace + [
		':root { --aeyde-shadow: 0px 0px 5px -2px #00000040; --aeyde-user-msg-bg: #FFFFFF; --aeyde-system-msg-bg: #F1F1F2; }',
		'* { font-family: "Aeyde Grotesk", sans-serif !important; font-weight: normal !important; color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; border-radius: 10px !important; border-color: #959595 !important; line-height: 1.3 !important; }',
		'textarea { border-color: transparent !important; }',
		'#gorgias-chat-messenger-button { background: #FFFFFF !important; box-shadow: var(--aeyde-shadow) !important; border-radius: 50% !important; overflow: visible !important; }',
		'#gorgias-chat-messenger-button > div[class] { background: transparent !important; backdrop-filter: none !important; -webkit-backdrop-filter: none !important; }',
		'#gorgias-chat-messenger-button > div { box-shadow: none !important; }',
	].join(' ');

	const bagMaskURL = 'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 27 31%27%3E%3Cpath d=%27M20.255 8.2708H19.4685V6.72644H19.4688L19.4682 6.71422C19.3163 3.61213 16.8843 1.1582 13.9087 1.1582C10.9332 1.1582 8.50109 3.61212 8.34932 6.71423L8.34902 6.71421V6.72644V8.2708H6.98593C4.74418 8.19234 2.80604 9.86736 2.43074 12.1732L2.43058 12.1732L2.42944 12.1822L0.783824 25.2915C0.632876 26.4921 0.991808 27.7031 1.77044 28.5997C2.67446 29.6655 3.97414 30.2721 5.33703 30.2588H21.6486C22.996 30.2913 24.2913 29.7197 25.2133 28.6929L25.2163 28.6895C26 27.7843 26.3648 26.5649 26.2182 25.3535L24.8119 12.2312L24.8104 12.2199C24.4537 9.89703 22.5122 8.19427 20.255 8.2708ZM6.98189 10.2687H8.30721V12.6139C8.30721 13.149 8.72155 13.6054 9.26047 13.6054C9.7994 13.6054 10.2137 13.149 10.2137 12.6139V10.2539H17.5201V12.5991C17.5201 12.8574 17.617 13.1087 17.7944 13.2957C17.9723 13.4833 18.2167 13.5906 18.4734 13.5906C18.7301 13.5906 18.9745 13.4833 19.1523 13.2958C19.3298 13.1087 19.4267 12.8574 19.4267 12.5991V10.2539H20.2175V10.2543L20.2309 10.2535C21.5036 10.185 22.6449 11.1233 22.8814 12.4708L24.287 25.572L24.288 25.58C24.3755 26.2038 24.2081 26.8347 23.8317 27.3199L23.7804 27.386L23.7804 27.3907C23.2356 27.9786 22.4881 28.3023 21.7119 28.2909H21.7083H5.33622L5.33203 28.2909C4.52497 28.3044 3.74971 27.9494 3.20576 27.311L3.20395 27.3089C2.79451 26.839 2.59856 26.2001 2.67292 25.5604L4.31751 12.4593C4.56475 11.1218 5.70274 10.1981 6.96803 10.2683H6.98189ZM10.2136 8.27089L10.2137 6.73382C10.3349 4.68152 11.9437 3.10044 13.8668 3.10044C15.79 3.10044 17.3988 4.68147 17.52 6.73381V8.27089H10.2136Z%27/%3E%3C/svg%3E")';

	const windowCSS = customCSS + ' ' + [
		'button { outline: none !important; }',
		'button[role="button"] { border: none !important; padding: var(--spacing-sm) !important; background: var(--aeyde-system-msg-bg) !important; color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; }',
		'button[role="button"]:not(:disabled) { background: #FFFFFF !important; }',
		'#conversation button[aria-label="Like"], #conversation button[aria-label="Dislike"] { background: transparent !important; padding: 0 !important; box-shadow: none !important; }',
		'#conversation button[aria-label="Add attachment"] { box-shadow: none !important; background: transparent !important; }',
		'[data-testid="status-indicator-container"], [data-testid="status-indicator-container"] div { background: none !important; }',
		'[data-testid="reveal-animation"] { overflow-y: visible !important; overflow-x: hidden !important; }',
		'[data-testid="reveal-animation-overlay"] { display: none !important; }',
		'div[class*="message-window-iframe"]:not(:has(#auth-email)) { border: none !important; }',
		'div:has(> span > button[role="button"][aria-label*=" message"]), div:has(> div > span > button[role="button"][aria-label*=" message"]) { background: transparent !important; }',
		'button[aria-label="Like"] svg, button[aria-label="Dislike"] svg { overflow: visible !important; }',
		'#conversation [role="note"] *, #conversation [role="note"], [role="note"][role="note"] *, [role="note"][role="note"] { box-shadow: none !important; background: transparent !important; border: none !important; }',
		'#homepage-header { margin-top: 24px !important; }',
		'#homepage-header ~ div button { border: none !important; box-shadow: var(--aeyde-shadow) !important; }',
		'div:has(> #homepage-header) { overflow: visible !important; }',
		'[role="status"] { overflow: visible !important; }',
		'[role="status"] span { color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; }',
		'[data-is-focused] { border-color: transparent !important; box-shadow: var(--aeyde-shadow) !important; }',
		'[data-testid="footer-component"] > div { box-shadow: var(--aeyde-shadow) !important; }',
		'textarea { background: #FFFFFF !important; border-color: transparent !important; }',
		'[data-testid="footer-component"] { background: #FFFFFF !important; }',
		'[data-testid="footer-component"] > * { background: #FFFFFF !important; }',
		'[role="dialog"][aria-label="Sign in"], [role="dialog"][aria-label="Sign in"] *:not(button[type="submit"]) { background: #FFFFFF !important; }',
		'[role="dialog"][aria-label="Sign in"] button[type="submit"] { color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; background: var(--aeyde-system-msg-bg) !important; }',
		'#conversation-floating-header button { box-shadow: var(--aeyde-shadow) !important; border: none !important; background: #FFFFFF !important; max-height: 32px !important; }',
		'#conversation-floating-header button svg { transform: scale(1.44) !important; }',
		'#conversation-floating-header, #conversation-floating-header * { border: none !important; }',
		'#conversation-floating-header div { gap: var(--spacing-xs) !important; }',
		'#conversation-floating-header { background: #ECECEC !important; box-shadow: var(--aeyde-shadow) !important; border-radius: 0 !important; }',
		'#conversation-floating-header div { background: transparent !important; }',
		'.badge-count { color: black !important; }',
		'button[aria-label="Close"] svg { width: 10px !important; height: 10px !important; }',
		'button[aria-label="Track orders"] svg { width: 14px !important; height: 14px !important; }',
		'#header-view-cart-button, #header-view-cart-button div { overflow: visible !important; }',
		'#header-view-cart-button { padding: 10px !important; }',
		'#header-view-cart-button svg { display: none !important; }',
		'#header-view-cart-button div { width: 29px !important; height: 24px !important; background-color: #1E242E !important; -webkit-mask-image: ' + bagMaskURL + ' !important; mask-image: ' + bagMaskURL + ' !important; -webkit-mask-size: contain !important; mask-size: contain !important; -webkit-mask-repeat: no-repeat !important; mask-repeat: no-repeat !important; -webkit-mask-position: center !important; mask-position: center !important; }',
		'@media screen and (max-width: 768px) { #header-view-cart-button { padding: 10px !important; } #header-view-cart-button div { width: 23px !important; height: 17px !important; } }',
		'[data-testid="image-slide"]::before, [data-testid="image-slide"]::after { backdrop-filter: none !important; filter: none !important; background: none !important; }',
		'div[id]:has([data-testid="status-indicator-container"]) + div[id]:has([data-testid="status-indicator-container"]) { margin-top: 24px !important; }',
		'#conversation { background-color: #ECECEC !important; }',
		'#self-service-portal-container { background-color: #ECECEC !important; }',
		'::-webkit-scrollbar { width: 4px !important; }',
		'::-webkit-scrollbar-track { background: transparent !important; }',
		'::-webkit-scrollbar-thumb { background: #959595 !important; border-radius: 10px !important; }',
		'* { scrollbar-width: thin !important; scrollbar-color: #959595 transparent !important; }',
		'.frame-content { box-shadow: var(--aeyde-shadow) !important; }',
		'div:has(> .inner-content) { background: transparent !important; overflow: visible !important; }',
		'div:has(> span > button[role="button"]) { background: transparent !important; }',
		'[data-testid="status-indicator-container"] ~ * .inner-content, div:has(> [data-testid="status-indicator-container"]) .inner-content, div:has(> div > [data-testid="status-indicator-container"]) .inner-content { background-color: var(--aeyde-system-msg-bg) !important; border: none !important; box-shadow: var(--aeyde-shadow) !important; padding: var(--spacing-sm) !important; }',
		'div.inner-content { border: none !important; background: var(--aeyde-system-msg-bg) !important; box-shadow: var(--aeyde-shadow) !important; padding: var(--spacing-sm) !important; color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; }',
		'p.inner-content.inner-content { border: none !important; background: var(--aeyde-user-msg-bg) !important; box-shadow: var(--aeyde-shadow) !important; padding: var(--spacing-sm) !important; color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; }',
		'.inner-content *, .inner-content p, .inner-content span, .inner-content div { color: #1a1a1a !important; -webkit-text-fill-color: #1a1a1a !important; }',
		'#conversation button { border-style: none !important; border-width: 0 !important; border-color: transparent !important; box-shadow: var(--aeyde-shadow) !important; }',
	].join(' ');

	const buttonCSS = customCSS + ' svg[data-custom="aeyde"] { overflow: visible !important; padding: 3px !important; } #gorgias-chat-messenger-button, #gorgias-chat-messenger-button > div, #gorgias-chat-messenger-button > div > * { overflow: visible !important; } #gorgias-chat-messenger-button svg:not([data-custom="aeyde"]) { display: none !important; }';

	// Single source of the icon: the theme launcher in _boot--gorgias-chat.liquid.
	const customSvg = launcher()?.querySelector('svg[data-custom="aeyde"]')?.outerHTML || '';

	const container = () => document.querySelector(CONTAINER);
	const buttonIframe = () => document.querySelector(CONTAINER + ' #chat-button');
	const iframeDoc = (id) => container()?.querySelector(id)?.contentWindow?.document || null;
	const hasEmotionStyles = (head) => !!head && [...head.children].some((x) => x.getAttribute('data-emotion'));

	const revealButton = () => {
		const iframe = buttonIframe();
		if (!iframe) return;
		iframe.style.setProperty('opacity', '1', 'important');
		// The real button is fading in (0.4s): retire the theme launcher under it.
		const placeholder = launcher();
		if (placeholder) setTimeout(() => placeholder.remove(), 400);
	};

	// ─── On-demand loading ──────────────────────────────────────────────────
	// The Gorgias bundle (and Convert) used to load with every page. It now
	// loads on the first click on the launcher / an #open-live-chat link, or
	// once the page has been idle `loadDelay` seconds after `load`.
	let loading = null;

	const startRevealPoll = () => {
		const start = Date.now();
		const poll = setInterval(() => {
			if (!buttonIframe()) return;
			clearInterval(poll);
			setTimeout(revealButton, Math.max(0, 2000 - (Date.now() - start)));
		}, 100);
	};

	const loadWidget = () => {
		if (loading) return loading;
		loading = new Promise((resolve, reject) => {
			if (window.GorgiasChat) {
				resolve();
				return;
			}
			if (!appId) {
				reject(new Error('Gorgias chat: no app ID'));
				return;
			}
			window.addEventListener('gorgias-widget-loaded', () => resolve(), { once: true });
			const bundle = document.createElement('script');
			bundle.id = 'gorgias-chat-widget-install-v3';
			bundle.src = 'https://config.gorgias.chat/bundle-loader/' + encodeURIComponent(appId);
			bundle.async = true;
			bundle.onerror = () => reject(new Error('Gorgias chat: bundle failed to load'));
			document.head.appendChild(bundle);
			if (convertId) {
				const convert = document.createElement('script');
				convert.src = 'https://static.9gtb.com/loader.js?g_cvt_id=' + encodeURIComponent(convertId);
				convert.async = true;
				document.head.appendChild(convert);
			}
			startRevealPoll();
		});
		loading.catch(() => {
			loading = null; // let a later click retry
		});
		return loading;
	};

	// `window.GorgiasChat` exists as soon as the loader runs, but every API
	// call (open, isOpen…) throws until `init()` resolves. Only touch the API
	// once this is true.
	let chatReady = false;

	const whenReady = () =>
		loadWidget()
			.then(() => window.GorgiasChat.init())
			.then(() => {
				chatReady = true;
			});

	const showAndOpen = () => {
		const el = container();
		if (el) el.style.display = 'block';
		window.GorgiasChat.open();
	};

	const openChat = () => {
		if (chatReady) {
			showAndOpen();
			return;
		}
		const placeholder = launcher();
		placeholder?.setAttribute('data-loading', '');
		placeholder?.setAttribute('aria-busy', 'true');
		whenReady()
			.then(showAndOpen)
			.catch((error) => console.warn(error?.message || error))
			.finally(() => {
				placeholder?.removeAttribute('data-loading');
				placeholder?.removeAttribute('aria-busy');
			});
	};

	const toggleChat = () => {
		if (!chatReady) {
			openChat();
			return;
		}
		const el = container();
		if (window.GorgiasChat.isOpen() && el && el.style.display === 'block') {
			window.GorgiasChat.close();
		} else {
			openChat();
		}
	};

	window.openChatbot = openChat;
	window.enableChatbot = toggleChat;

	document.addEventListener('click', (event) => {
		const link = event.target.closest('a[href="#open-live-chat"]');
		if (!link) return;
		event.preventDefault();
		openChat();
	});

	launcher()?.addEventListener('click', toggleChat);

	window.addEventListener('resize', () => {
		if (chatReady && !window.GorgiasChat.isOpen()) {
			const el = container();
			if (el) el.style.display = 'none';
		}
	});

	// Idle load: after `load`, plus `loadDelay` seconds, when the main thread
	// is free. A prerendered page waits until it is actually shown.
	if (loadDelay > 0) {
		const schedule = () => {
			setTimeout(() => {
				const go = () => whenReady().catch((error) => console.warn(error?.message || error));
				'requestIdleCallback' in window ? requestIdleCallback(go, { timeout: 2000 }) : go();
			}, loadDelay * 1000);
		};
		const afterLoad = () => {
			if (document.readyState === 'complete') schedule();
			else window.addEventListener('load', schedule, { once: true });
		};
		if (document.prerendering) document.addEventListener('prerenderingchange', afterLoad, { once: true });
		else afterLoad();
	}

	const ready = window.GorgiasChat
		? window.GorgiasChat.init()
		: new Promise((resolve) => window.addEventListener('gorgias-widget-loaded', resolve));

	ready.then(() => {
		const initTime = Date.now();
		let replaceIcon = null;
		let iconIntervalStarted = false;
		const buttonStyle = document.createElement('style');
		buttonStyle.textContent = buttonCSS;

		const buttonTimer = setInterval(() => {
			const doc = iframeDoc('#chat-button');
			const head = doc?.querySelector('head');
			if (!hasEmotionStyles(head)) return;
			clearInterval(buttonTimer);
			head.appendChild(buttonStyle);
			setTimeout(revealButton, Math.max(0, 2000 - (Date.now() - initTime)));

			const btn = doc.querySelector('#gorgias-chat-messenger-button');
			if (!btn) return;

			const clearBg = () => {
				const liveBtn = iframeDoc('#chat-button')?.querySelector('#gorgias-chat-messenger-button');
				if (!liveBtn) return;
				for (const div of liveBtn.children) {
					if (div.tagName !== 'DIV') continue;
					div.style.setProperty('background', 'transparent', 'important');
					div.style.setProperty('backdrop-filter', 'none', 'important');
					div.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
				}
			};

			replaceIcon = () => {
				const liveDoc = iframeDoc('#chat-button');
				if (!liveDoc) return;
				const liveHead = liveDoc.querySelector('head');
				if (liveHead && !liveHead.contains(buttonStyle)) liveHead.appendChild(buttonStyle);
				const liveBtn = liveDoc.querySelector('#gorgias-chat-messenger-button');
				if (!liveBtn) return;
				const svgDiv = [...liveBtn.children].find((d) => d.querySelector('svg'));
				if (!customSvg || !svgDiv || svgDiv.querySelector('[data-custom="aeyde"]')) return;
				const parsed = new DOMParser().parseFromString(customSvg, 'image/svg+xml').documentElement;
				parsed.setAttribute('data-custom', 'aeyde');
				svgDiv.appendChild(parsed);
				liveBtn.style.setProperty('opacity', '1', 'important');
			};

			clearBg();
			replaceIcon();
			new MutationObserver(clearBg).observe(btn, { attributes: true, attributeFilter: ['style', 'class'] });
		}, 50);

		window.GorgiasChat.on('widget:opened', () => {
			if (!iconIntervalStarted) {
				iconIntervalStarted = true;
				setInterval(() => replaceIcon?.(), 300);
			}
			const windowTimer = setInterval(() => {
				const head = iframeDoc('#chat-window')?.querySelector('head');
				if (!hasEmotionStyles(head)) return;
				clearInterval(windowTimer);
				const windowStyle = document.createElement('style');
				windowStyle.textContent = windowCSS;
				head.appendChild(windowStyle);
			}, 50);
		});

		window.GorgiasChat.on('widget:closed', () => {
			let retries = 0;
			const closeInterval = setInterval(() => {
				replaceIcon?.();
				revealButton();
				if (++retries > 10) clearInterval(closeInterval);
			}, 50);
		});
	});
})();
